'format es6';
'use strict';

import $ from 'jquery';
import ns from 'ns';
import gsap from 'greensock';


function Menu(){
	let $window = $(window);
	let menu = $('.menu');
	let menuItems = menu.find('.scrollto');
	let menuClose = menu.find('.close-btn');
	let menuBtn = $('.menu-btn');
	let pageOverlay = $('.page-overlay');
	let pageWrap = $('.page-wrap');

	let scroll = {y:$window.scrollTop()};

	let handleMenuOpenClose = (e)=>{
		if(e){
			e.preventDefault();
			e.stopPropagation();
		}

		let dfd = $.Deferred();

		if(pageWrap.hasClass('opened')){
			menuBtn.on('click.psy_menu', handleMenuOpenClose);
			menuClose.off('click.psy_menu');
			pageOverlay.off('click.psy_menu');
		}
		else {
			menu.show();
			menuBtn.off('click.psy_menu');
			menuClose.on('click.psy_menu', handleMenuOpenClose);
			pageOverlay.on('click.psy_menu', handleMenuOpenClose);
		}

		pageWrap.toggleClass('opened');

		setTimeout(()=>{
			if(!pageWrap.hasClass('opened')){
				menu.hide();
			}

			dfd.resolve();
		}, 300)

		return dfd;
	};

	let handleMenuItems = (e)=>{
		e.preventDefault();
		e.stopPropagation();

		let clicked = $(e.target);
		menuItems.removeClass('active');
		clicked.addClass('active');
		let targetTab = $('[data-scrollto-section="' + clicked.data('scrollto') + '"]');
		let targetPos = targetTab.offset().top - $('header').height();

		$.when(handleMenuOpenClose()).then(()=>{
			switchTab(targetPos);
		});/**/
	};

	let switchTab = (targetPos)=> {
		scroll = {y:$window.scrollTop()};
		
		gsap.TweenMax.to(scroll, 1.2, {
			y: targetPos,
			ease:gsap.Expo.easeInOut,
			delay:0,
			onUpdate:()=>{
				$window.scrollTop(scroll.y);
			}
		});
	};

    let init = ()=>{
    	menuItems.on('click.psy_menu', handleMenuItems);
    	menuBtn.on('click.psy_menu', handleMenuOpenClose);
    };

    return {
        init: init
    };
};


export default Menu;
